export default __webpack_public_path__ + "static/media/admin.0c569e89.png";